<template>
  <div class="social-links">
    <button
      v-for="social in socialLinks"
      :id="social.id"
      :key="social.id"
      :title="$t(social.provider)"
      :disabled="accountLinked(social.provider)"
      class="btn btn-blue"
      @click="redirectToProvider(social.provider)"
    >
      <i
        class="fa-brands fa-fw"
        :class="social.icon"
      />
    </button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "LinkSocial",

  computed: {
    ...mapGetters(["user"]),

    socialLinks() {
      return [
        {
          id: "account_security_button_linkfb",
          icon: "fa-facebook-f",
          provider: "facebook",
        },
        {
          id: "account_security_button_linkgoog",
          icon: "fa-google",
          provider: "google",
        },
        {
          id: "account_security_button_linktwtr",
          icon: "fa-x-twitter",
          provider: "twitter",
        },
        {
          id: "account_security_button_linkmsft",
          icon: "fa-windows",
          provider: "microsoft",
        },
      ];
    },
  },

  methods: {
    redirectUrl(provider) {
      return this.$appUrl("login/{provider}", {
        provider: provider,
      });
    },

    accountLinked(provider) {
      return this.user && _.size(this.user[provider + "_id"]) > 0;
    },

    redirectToProvider(provider) {
      window.location.href = this.redirectUrl(provider);
    },
  },
};
</script>

<style lang="scss" scoped>
.social-links {
  gap: 0.25rem;
}
</style>
